var content = require("!!../../../../../../../../node_modules/postcss-loader/src/index.js??embedded!../../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-3-2!./login-1.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
